import "./FooterStyles.css";
import React from "react";
import config from "../contact/config";
// import TwitterLogo from "../path-to-assets/twitter.svg";
import TwitterLogo from "../../assets/twitter.svg"

import {
  // FaHome,
  // FaPhone,
  FaMailBulk,
  FaLinkedin,
  // FaTwitter,
  FaFacebook,
  FaGraduationCap,
  // FaBuilding,
  // FaRegBuilding,
  FaCertificate,
  FaNewspaper,
  // FaPlane,
} from "react-icons/fa";
export const Footer = () => {
  const myDesignation = config.myDesignation;
  const contactName = config.contactName;
  
  const myCurrentRole = config.myCurrentRole;  
  // const myPhoneNumber = config.myPhoneNumber;
  // const myAddress1 = config.myAddress1;    
  // const myAddress2 = config.myAddress2; 
  // const contactEmail = config.contactEmail;    
  const contactEmail1 = config.contactEmail1;    
  const contactFacebookLink = config.contactFacebookLink;    
  const contactLinkedinLink = config.contactLinkedinLink;    
  const contactXLink = config.contactXLink; 
  const contactArticlesLink = config.contactArticlesLink; 
  // const mySkills = config.mySkills;    
  const mySkills1 = config.mySkills1;    
  const myEducation1 = config.myDegree1 ; 
  const myEducation2 = config.myDegree2;
  const myCertification = config.myCertificate;  
  const myDeploma = config.myDeploma;    
  
  
  return (
    <div className="footer">
      <div className="footer-container">
        <div className="left">
          {/* <div className="location">
            <FaHome size={20} style={{ color: "#fff", marginRight: "2rem" }} />
            <div>
              <p>{myAddress1} {myAddress2}</p>
            </div>
          </div>
          <div className="location">
            <FaPhone size={20} style={{ color: "#fff", marginRight: "2rem" }} />
            <div>
              <p>{myPhoneNumber}</p>
            </div>
          </div>                     */}
          <div className="location">
            <FaMailBulk size={20} style={{ color: "#fff", marginRight: "2rem" }} />
            <div>
              <p>{contactEmail1}</p>
            </div>
          </div>          
          <div className="location">
            <FaGraduationCap size={20} style={{ color: "#fff", marginRight: "2rem" }} />
            <div>
              <p>{myEducation1}</p>
              <p>{myEducation2}</p>
            </div>
          </div>
          <div className="location">
            <FaCertificate size={20} style={{ color: "#fff", marginRight: "2rem" }} />
            <div>
              <p>{myCertification}</p>
              <p>{myDeploma}</p>
            </div>
          </div>
                 
        </div>

        <div className="right">
          <h4>About the {myDesignation}</h4>
          <p>
            This is {contactName}. {myCurrentRole}.{mySkills1}
          </p>

          <div className="social">
            <a href={contactFacebookLink} target="_blank" rel="noopener noreferrer">
            <FaFacebook size={20} style={{ color: "#fff", marginRight: "2rem" }} />
            </a>
            <a href={contactLinkedinLink} target="_blank" rel="noopener noreferrer">
            <FaLinkedin size={20} style={{ color: "#fff", marginRight: "2rem" }} />
            </a>
            <a href={contactArticlesLink} target="_blank" rel="noopener noreferrer">
            <FaNewspaper size={20} style={{ color: "#fff", marginRight: "2rem" }} />
            </a>            
            <a href={contactXLink} target="_blank" rel="noopener noreferrer">
            <img src={TwitterLogo} alt="Twitter Logo" style={{ width: "20px", marginRight: "2rem" }} />

            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
